import React from 'react';
import { NavLink } from 'react-router-dom';
// import '../../styles/footer.css';
const Footer = () => {
  return (
    <footer className="footer">
		<div className="container-fluid">
			<div className="row text-muted">
				<div className="col-12 text-center">
					<p className="mb-0 text-dark">
					<NavLink
					to="/dashboard"
					target="_blank"
					className="text-muted"
					>
					<strong>Admin Dashboard</strong>
					</NavLink>{" "}
					&copy; {new Date().getFullYear()} All rights reserved.
					</p>
				</div>
				{/* <div className="col-6 text-end">
					<ul className="list-inline">
						<li className="list-inline-item">
							<NavLink className="text-dark" to="#">Support</NavLink>
						</li>
						<li className="list-inline-item">
							<NavLink className="text-dark" to="#">Help Center</NavLink>
						</li>
						<li className="list-inline-item">
							<NavLink className="text-dark" to="#">Privacy</NavLink>
						</li>
						<li className="list-inline-item">
							<NavLink className="text-dark" to="#">Terms</NavLink>
						</li>
					</ul>
				</div> */}
			</div>
		</div>
	</footer>
  );
};

export default Footer;